import { NgModule } from '@angular/core';        
      import { InfoDatosRoutingModule } from './info-datos-routing.module';
      import { InfoDatosComponent } from './container/info-datos.component';
      import { SharedModule } from 'shared';
      import { CoreComponentsModule } from '@app/core';
      import { NgxsModule } from '@ngxs/store';
      import { InfoDatosBdState } from './store/states/info-datos.state';
import { TabInformacionComponent } from './componentes/tab-informacion/tab-informacion.component';
import { SectionBandejaDatosComponent } from './componentes/section-bandeja-datos/section-bandeja-datos.component';
      
  
      @NgModule({
        declarations: [
          InfoDatosComponent,
          TabInformacionComponent,
          SectionBandejaDatosComponent
          
        ],
        imports: [
          InfoDatosRoutingModule,
          SharedModule,
          CoreComponentsModule,
          NgxsModule.forFeature([
            InfoDatosBdState
          ])
        ],
        entryComponents: [],
        
      })
      export class InfoDatosModule { }
    